// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function buildFormData(formData: FormData, data: any, parentKey?: any) {
  if (
    data &&
    typeof data === 'object' &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    const value = data === null ? '' : data;

    if (data !== undefined && data !== null) {
      formData.append(parentKey, value);
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function buildFormDataObjectAsString(formData: FormData, data: any) {
  if (data && typeof data === 'object') {
    Object.keys(data).forEach((key) => {
      if (
        typeof data[key] === 'object' &&
        data[key] &&
        !(data[key] instanceof Date) &&
        !(data[key] instanceof File)
      ) {
        const value = data[key] === null ? '' : JSON.stringify(data[key]);
        formData.append(key, value);
      } else {
        const value = data[key] === null ? '' : data[key];
        if (data[key] !== undefined && data[key] !== null) {
          formData.append(key, value);
        }
      }
    });
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function jsonToFormData(data: any) {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function jsonToFormDataAsString(data: any) {
  const formData = new FormData();
  buildFormDataObjectAsString(formData, data);
  return formData;
}
